const utils = require('frontend-controller/lib/utils')
const Chart = require('chart.js')

module.exports = {
	config: {
		chartProperties: {
			type: 'doughnut',
			data: [],
			options: {
				legend: {
					display: false
				},
				tooltips: {
					// enabled: false
				},
				// animation: {
				// 	duration: 0 // general animation time
				// },
				hover: {
					animationDuration: 0 // duration of animations when hovering an item
				},
				cutoutPercentage: 65,
				rotation: -1.125 * Math.PI,
				circumference: 1.25 * Math.PI,
				// maintainAspectRatio: false,
				aspectRatio: 1,
				// responsive: false,
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 0,
						bottom: 0
					}
				}
			}
		}
	},

	model: {
		chartProperties: {},
		title: 'UNDEFINED',
		value: '0.00 %',
		footer: '...',
	},

	methods: {
		initChart: function(){
			if(!this.model.chart && this.$.length > 0){
				this.model.chart = new Chart(this.$.find('> .overlay > .canvasContainer > canvas'), this.model.chartProperties)
			}
		},

		update(){
			if(!this.model.table) return;

			const nrOfElements = (((this.model.table.resourceData || {}).nrOfElements || {}).data || {}).attributes || {}

			if(utils.isEqual(nrOfElements, this.model.nrOfElements)) return;
			this.model.nrOfElements = nrOfElements

			this.initChart()

			if(this.model.chart){

				const overall = nrOfElements.nrOfElements || 0
				const value = overall - (nrOfElements.nrOfMatchingElements || 0)

				// if(overall > 0){
				// 	this.model.chart.data.labels = [
				// 		this.model.title,
				// 		'Andere'
				// 	]
				// 	this.model.value = `${parseFloat(value * 100 / overall).toFixed(1)} %`.replace('.', ',')
				// 	this.model.footer = `${value} / ${overall}`
				// 	this.model.chart.data.datasets[0].data = [value, overall - value]
				// } else {
				// 	this.model.chart.data.labels = [
				// 		'Andere'
				// 	]
				// 	this.model.value = `${parseFloat(0).toFixed(1)} %`.replace('.', ',')
				// 	this.model.footer = '0'
				// 	this.model.chart.data.datasets[0].data = [1]
				// }
				this.model.chart.data.labels = [
					this.model.title,
					'Andere'
				]
				if(overall > 0){
					this.model.value = `${parseFloat(value * 100 / overall).toFixed(1)} %`.replace('.', ',')
					this.model.footer = `${value} / ${overall}`
					this.model.chart.data.datasets[0].data = [value, overall - value]
				} else {
					this.model.value = `${parseFloat(0).toFixed(1)} %`.replace('.', ',')
					this.model.footer = '0'
					this.model.chart.data.datasets[0].data = [1, 0]
				}

				this.refresh(false, { updateChart: true })
			}
		},
	},

	hooks: {
		// async update($element, options) {
		// 	await this.update((options || {}).nrOfElements)
		// },

		attach: function($element, options){

			if(!this.model.table){
				this.locate('< templates_office_dashboard_element_controller > templates_core_table_table', t => this.model.table = t)
			}


			if(options.updateChart){
				this.model.chart.destroy()
				delete this.model.chart
				this.initChart()

				requestAnimationFrame(() => this.model.chart.update())
			} else {

				// in case of refreshes the chart-dom-binding has to be renewed
				if (this.model.chart && (options || {}).refresh){
					this.model.chart.destroy()
					delete this.model.chart
				}
				if(!this.model.chart){
					this.model.chartProperties = this.config.chartProperties

					// const type = (this.model.type || {}).data || 'received'

					this.model.title 			= 'Erledigt'
					this.model.primaryColor		= '#006600'
					this.model.secondaryColor	= '#888888'
					// if(type === 'received'){
					// 	this.model.title 		= 'Zugestellt'
					// 	this.model.primaryColor	= '#006600'
					// } else if (type === 'views') {
					// 	this.model.title 		= 'Gelesen'
					// 	this.model.primaryColor	= '#ECCB00'
					// } else if (type === 'clicks') {
					// 	this.model.title 		= 'Klicks'
					// 	this.model.primaryColor	= '#F3860A'
					// } else if (type === 'unsubscribed') {
					// 	this.model.title 		= 'Abgemeldet'
					// 	this.model.primaryColor	= '#3076B2'
					// }


					this.model.chartProperties.data = {
						datasets: [{
							data: [],
							backgroundColor: [
								this.model.primaryColor,
								this.model.secondaryColor,
							],
							hoverBackgroundColor: [
								this.model.primaryColor,
								this.model.secondaryColor,
							],
							borderColor: [
								'#FCFCFC',
								'#FCFCFC',
							],
							categoryPercentage: 1,
							barPercentage: 1,
						}]
					}
					// this.initChart()

					this.update()
				}
			}
		}
	},

	handlers: [
		{
			name: 'refreshResources',
			handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
				if(this.model.table && this.model.table.componentIndex === callerComponent.componentIndex){
					this.update()
				}
			}
		},
	]
}
